/**
 * The purpose of this module is for opening and closing university-badge modals
 */

export default {
    state: {
        isOpen: false,
        selectedUniConnection: null,
    },
    getters: {
        isOpen: state => () => Boolean(state.isOpen),
        getSelected: state => () => state.selectedUniConnection,
    },
    mutations: {
        setOpen(state, isOpen) {
            state.isOpen = isOpen;
        },
        setSelected(state, uniConnection) {
            state.selectedUniConnection = uniConnection;
        },
        setOpenAndSelected(state, newState) {
            state.isOpen = newState.isOpen;
            state.selectedUniConnection = newState.selected;
        },
    },
};
